import { Decoder, field, succeed } from 'jsonous';
import { readonlyArray } from '../../../../../../../Decoders';
import { resourceDecoder } from '../../../../../../../Resource/Decoders';
import { licenseDecoder } from '../../../Stores/ShareStore/Decoders';
import { SearchOptions, SearchOptionsResource } from './Types';

const searchOptionsDecoder: Decoder<SearchOptions> = succeed({}).assign(
  'licenses',
  field('licenses', readonlyArray(licenseDecoder)),
);

export const searchOptionsResourceDecoder: Decoder<SearchOptionsResource> =
  resourceDecoder(searchOptionsDecoder);
